<!-- <div class="color-display" (click)="toggleColorPicker()" *ngIf="id" style="z-index: 9999;">
  <div class="w-6 h-6 rounded-lg" [ngStyle]="{'background-color': value}"></div>
  <div *ngIf="showColorPicker" class="absolute mt-2">
      <chrome-picker id="{{id}}"  [(color)]="value" (colorChange)="colorChanged($event)" ></chrome-picker>
  </div>
</div> -->

<!-- <chrome-picker id="{{id}}" *ngIf="showColorPicker" [(color)]="value" (colorChange)="colorChanged($event)" class="absolute  mt-2" style="z-index: 999;" ></chrome-picker> -->

<div
  class="color-display"
  (click)="toggleColorPicker()"
  *ngIf="id"
  style="position: relative; z-index: 9999"
>
  <div
    class="w-6 h-6 rounded-lg"
    [ngStyle]="{ 'background-color': value }"
  ></div>
  <div
    *ngIf="showColorPicker"
    class="color-picker-container"
    style="position: absolute; z-index: 10000"
  >
    <chrome-picker
      id="{{ id }}"
      [(color)]="value"
      (colorChange)="colorChanged($event)"
    ></chrome-picker>
  </div>
</div>
